var React = require('react');

function Wheel (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M50,250c0-110.5,89.5-200,200-200s200,89.5,200,200s-89.5,200-200,200S50,360.5,50,250","id":"circle"})),React.createElement("text",{"dy":"36","textRendering":"optimizeLegibility","key":1},React.createElement("textPath",{"className":"wheel-text","href":"#circle"},"Restoration • Development • Residential • Commercial • Ideation •\n      Investment • "))]);
}

Wheel.defaultProps = {"viewBox":"0 0 500 500","id":"#circle","className":"wheel"};

module.exports = Wheel;

Wheel.default = Wheel;
